import styled, { css } from 'styled-components';

const Icon = styled.span<{ interactable?: boolean, active?: boolean, icon: any, size?: number }>`
  background-image: url("data:image/svg+xml,${props => props.icon(props.active ? '#000000' : undefined)}");
  width: ${props => props.size ?? 24}px;
  height: ${props => props.size ?? 24}px;
  display: inline-block;
  vertical-align: middle;
  
  ${props => props.interactable && css`
    cursor: pointer;
    &:hover {
      background-image: url("data:image/svg+xml,${props.icon('#000000')}");
    }
  `}
`;

export default Icon;